<template>

	<section class="blog--wrap">
		<div class="wrapper blog flex direction-column align-center">
			<h3 class="blog__title">{{ $t('blog.title') }}</h3>

			<ul class="blog__item--wrap flex justify-between wrap">
				<li
					class="blog__item flex direction-column"
					v-for="(item, index) in blogPosts" :key="index"
				>
					<a :href="item.url" class="blog__item__fakeLink"></a>
					<div class="blog__item__category--wrap">

						<a
							v-if="item.isVideo"
							:href="generateUrl('/blog/label/video')" target="_blank"
							class="blog__item__category NS-buttonXs"
							style="background-color: #ff5c38"
						>
							{{ $t('blog.video') }}
						</a>

						<a
							:href="item.category.url" target="_blank"
							class="blog__item__category NS-buttonXs"
							:style="{backgroundColor: item.category.color}"
						>
							{{ item.category.name }}
						</a>
					</div>
					<figure class="blog__item__img--wrap">
						<img :src="item.imageTile" alt="" class="blog__item__img">
					</figure>

					<div class="blog__item__author">

						<a :href="item.author.url" target="_blank" class="flex align-start link">
							<figure class="blog__item__author__photo--wrap">
								<img
									:src="item.author.imageSmall"
									:alt="item.author.name"
									class="blog__item__author__photo"
								>
							</figure>
							<span class="blog__item__author__name text-ellipsis">{{ item.author.name }}</span>
						</a>
						<p class="blog__item__date">{{ item.date }}</p>

					</div>

					<a :href="item.url" class="blog__item__name link">{{ item.title }}</a>

					<div class="blog__item__info flex align-center justify-between">
						<div class="blog__item__info__item">
							<i class="fa fa-eye"></i>
							{{ item.totalView }}
						</div>
						<div class="blog__item__info__item">
							<i class="fa fa-thumbs-o-up"></i>
							{{ item.totalVote }}
						</div>
						<div class="blog__item__info__item">
							<i class="fa fa-share"></i>
							{{ item.totalShare }}
						</div>
						<a :href="`${item.url}#c`"
						   target="_blank" class="blog__item__info__item link"
						>
							<i class="fa fa-comments-o"></i>
							{{ item.totalComment }}
						</a>
					</div>
				</li>
			</ul>

			<a :href="generateUrl('/blog')" target="_blank"
			   class="NS-button NS-button__gradient NS-button__gradient__darkSkyBlue blog__link"
			>
				{{ $t('blog.linkToBlog') }}
			</a>
		</div>
	</section>

</template>

<script>

	import { generateUrl } from "@/plugin/mixins";

	export default {
		computed: {
			blogPosts() {
				return this.$store.state.blogPosts;
			}
		},
		mixins: [generateUrl]

	}

</script>